export default __webpack_public_path__ + "c6641d828cfe37752bacea8af138d278.png";